/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_data_sources_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All fantasy points and price data is sourced from the official F1 Fantasy game. Race results and timing data are sourced from Formula 1's official records. Coverage starts from 2023, with every season added as it runs.`)
};

const es_about_data_sources_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los puntos fantasy y datos de precios provienen del juego oficial F1 Fantasy. Los resultados de carrera y datos de tiempos provienen de los registros oficiales de Formula 1. La cobertura comienza desde 2023, con cada temporada añadida conforme transcurre.`)
};

const de_about_data_sources_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Fantasy-Punkte und Preisdaten stammen aus dem offiziellen F1 Fantasy Spiel. Rennergebnisse und Zeitdaten stammen aus den offiziellen Formel-1-Aufzeichnungen. Die Abdeckung beginnt ab 2023, jede Saison wird hinzugefügt.`)
};

const nl_about_data_sources_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle fantasy-punten en prijsgegevens komen van het officiële F1 Fantasy-spel. Raceresultaten en tijdwaarnemingen komen uit de officiële Formule 1-gegevens. De dekking begint vanaf 2023, met elk seizoen dat wordt toegevoegd zodra het plaatsvindt.`)
};

const fr_about_data_sources_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les points fantasy et données de prix proviennent du jeu F1 Fantasy officiel. Les résultats de course et données chronométriques proviennent des archives officielles de la Formule 1. La couverture commence en 2023, chaque saison étant ajoutée au fur et à mesure.`)
};

const it_about_data_sources_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i punti fantasy e i dati sui prezzi provengono dal gioco ufficiale F1 Fantasy. I risultati delle gare e i dati cronometrici provengono dai record ufficiali della Formula 1. La copertura parte dal 2023, con ogni stagione aggiunta man mano che si svolge.`)
};

const pt_br2_about_data_sources_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os pontos fantasy e dados de preços são obtidos do jogo oficial F1 Fantasy. Resultados de corridas e dados de cronometragem são obtidos dos registros oficiais da Fórmula 1. A cobertura começa em 2023, com cada temporada adicionada conforme acontece.`)
};

const pt_about_data_sources_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os pontos fantasy e dados de preço têm origem no jogo oficial F1 Fantasy. Os resultados de corrida e dados de tempo são obtidos dos registos oficiais da Fórmula 1. A cobertura começa em 2023, com cada época adicionada à medida que decorre.`)
};

const ja_about_data_sources_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのファンタジーポイントと価格データは公式F1ファンタジーゲームから取得しています。レース結果とタイミングデータはF1の公式記録から取得。2023年から全シーズンをカバーし、各シーズンの進行に合わせて追加。`)
};

const zh_about_data_sources_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有梦幻积分和价格数据来源于官方F1 Fantasy游戏。比赛结果和计时数据来源于F1官方记录。数据覆盖从2023年开始，每个赛季随进行同步更新。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_data_sources_p1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_data_sources_p1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_data_sources_p1", locale)
	if (locale === "en") return en_about_data_sources_p1(inputs)
	if (locale === "es") return es_about_data_sources_p1(inputs)
	if (locale === "de") return de_about_data_sources_p1(inputs)
	if (locale === "nl") return nl_about_data_sources_p1(inputs)
	if (locale === "fr") return fr_about_data_sources_p1(inputs)
	if (locale === "it") return it_about_data_sources_p1(inputs)
	if (locale === "pt-BR") return pt_br2_about_data_sources_p1(inputs)
	if (locale === "pt") return pt_about_data_sources_p1(inputs)
	if (locale === "ja") return ja_about_data_sources_p1(inputs)
	return zh_about_data_sources_p1(inputs)
};